import gql from "graphql-tag";

export const GET_INTRODUCTION = gql`
    query Introduction($introductionId: ID!){
        introduction(introductionId: $introductionId) {
            introductionId
            userId
            contactId
            introductionContactId
            introductionContactName
            introductionContactLinkedinId
            introductionDirection
            introductionNote
            createdAt
            updatedAt
            introductionContact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
                displayName
                contactLastFirstName
                contactLinkedinId
            }
        }
    }
`;

export const GET_INTRODUCTIONS = gql`
    query Introductions($contactId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        introductions(contactId: $contactId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            introductionId
            userId
            contactId
            introductionContactId
            introductionContactName
            introductionContactLinkedinId
            introductionDirection
            introductionNote
            createdAt
            updatedAt
            introductionContact {
                contactId
                contactSalutation
                contactFirstName
                contactMiddleName
                contactLastName
                contactSuffix
                contactNickName
                displayName
                contactLastFirstName
                contactLinkedinId
            }
        }
    }
`;

export const CREATE_INTRODUCTION = gql`
    mutation CreateIntroduction($newIntroduction: newIntroduction!) {
        createIntroduction(
            newIntroduction: $newIntroduction
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_INTRODUCTION = gql`
    mutation UpdateIntroduction($changedIntroduction: changedIntroduction!) {
        updateIntroduction(
            changedIntroduction: $changedIntroduction
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_INTRODUCTION = gql`
    mutation DeleteIntroduction($deleteIntroductionId: ID!) {
        deleteIntroduction(
            deleteIntroductionId: $deleteIntroductionId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_INTRODUCTIONS = gql`
    mutation DeleteIntroductions($deleteIntroductionIds: [ID!]!) {
        deleteIntroductions(
            deleteIntroductionIds: $deleteIntroductionIds
        ) {
            returnCode
            message
        }
    }
`;
